import fpApiUtil from "./fp-api-util";

const ANALYSIS = "factoryplan/analysis";

// 자원 생산 계획(공장>스테이지>자원>공정>품목별 생산수량 크로스탭, 지연/과부하 강조) — 크로스탭 그리드용.
// AnalysisController#getResProdPlanList(백엔드는 factoryplan/analysis/res-prod-plan/grid). 다른
// 크로스탭 화면과 달리 피벗 컬럼마다 companion 배열(`pivotlateYnData`, 지연 여부)이 같이 내려온다
// (old setCrossTabGridDataWithBucketAndMultiPvtCol의 멀티 피벗 컬럼 대응). old도 stageCdNm/
// resourceCdNm/routeCdNm/itemCdNm 4개 필터를 실제로 params에 실어 보내고(ResProdPlanQueryRepository가
// 4개 모두 contains 조건으로 소비) 그리드/두 차트 전부 씀 — postParams만.
const getResProdPlans = (params) => fpApiUtil.postParams(`${ANALYSIS}/res-prod-plan/grid`, params);

// 품목 수급 차트(QTY/DMND_QTY/EOH 3종, 단일 y축) — 자원 칸이 아닌 다른 모든 레벨(공장/스테이지/공정/
// 품목/피벗 셀) 클릭 시 호출된다(AnalysisController#getResProdPlanItemChart).
const getResProdPlanItemChart = (params) => fpApiUtil.postParams(`${ANALYSIS}/res-prod-plan/item-chart`, params);

// 자원 가동 차트(USED_TIME/AVAIL_TIME/JC_TIME/USED_RATE/AVAIL_RATE 5종, 듀얼 y축) — 자원 칸 클릭 시만
// 호출된다(AnalysisController#getResProdPlanResChart). old도 이 호출만 stageCd를 안 보낸다(plantCd+
// resourceCd만) — old 그대로 이식.
const getResProdPlanResChart = (params) => fpApiUtil.postParams(`${ANALYSIS}/res-prod-plan/res-chart`, params);

const fpResProdPlanService = { getResProdPlans, getResProdPlanItemChart, getResProdPlanResChart };
export default fpResProdPlanService;
